<template>
  <v-container
    fluid
    style="min-height: calc(100vh - 58px); position: relative"
    class="pa-0"
  >
    <v-row style=" margin: 0; padding: 0; position: relative">
      <v-col cols="12" class="pa-0">
        <GlobalNav :key="componentKey" v-if="showNav" />
      </v-col>
      <v-col cols="12" class="pa-0 d-flex align-start ga-6">
        <SideBar />
        <div class="w-100 pa-3 is-light-mode position-relative">
          <BreadCrumb :linksData="linksData" class="mb-4" />
          <v-row>
            <v-col
              class="d-flex align-center ga-2 my-5"
              :lg="6"
              :md="12"
              :sm="12"
            >
              <router-link class="d-flex" to="/my-account">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="rgba(31, 102, 106, 1)"
                >
                  <path
                    d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"
                  ></path>
                </svg>
              </router-link>
              <span class="profile-box-main-text">{{
                $t("Edit My Account Info")
              }}</span>
            </v-col>
          </v-row>
          <div class="d-flex flex-column w-100 ga-5 mb-5">
            <!-- <ProfilePicture
              :profile="profile"
              :errors="errors"
              @change="handleImageChange"
            /> -->
            <div class="profile-box-container w-100">
              <div
                class="d-flex justify-space-between align-items-center w-100"
              >
                <div class="d-flex flex-column ga-4">
                  <label class="profile-box-title">
                    {{ $t("profile_picture") }}
                  </label>
                  <label class="profile-box-desc">
                    {{ $t("a_picture_helps_people_to_recognize_you") }}
                  </label>
                </div>

                <!-- Skeleton Loading -->
                <template v-if="loading">
                  <div class="d-flex align-center ga-4">
                    <v-skeleton-loader
                      type="avatar"
                      width="64"
                      height="64"
                      class="profile-picture"
                    />
                    <div class="d-flex flex-column ga-2">
                      <v-skeleton-loader type="text" width="150" height="20" />
                      <v-skeleton-loader type="text" width="100" height="16" />
                    </div>
                  </div>
                </template>

                <!-- Actual Content -->
                <template v-else>
                  <div class="d-flex align-center ga-4">
                    <span class="profile-picture position-relative">
                      <img :src="profilePicture" alt="" />
                      <span class="new-profile">
                        <svg
                          @click="UploadProfilePicture"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 14.5C11 14.5 11.8333 14.1597 12.5 13.4792C13.1667 12.7986 13.5 11.9722 13.5 11C13.5 10.0417 13.1667 9.21875 12.5 8.53125C11.8333 7.84375 11 7.5 10 7.5C9 7.5 8.16667 7.84375 7.5 8.53125C6.83333 9.21875 6.5 10.0451 6.5 11.0104C6.5 11.9757 6.83333 12.7986 7.5 13.4792C8.16667 14.1597 9 14.5 10 14.5ZM10 13C9.41667 13 8.9375 12.8047 8.5625 12.414C8.1875 12.0233 8 11.545 8 10.9792C8 10.425 8.1875 9.9566 8.5625 9.57396C8.9375 9.19132 9.41667 9 10 9C10.5833 9 11.0625 9.19132 11.4375 9.57396C11.8125 9.9566 12 10.425 12 10.9792C12 11.545 11.8125 12.0233 11.4375 12.414C11.0625 12.8047 10.5833 13 10 13ZM3.5 17C3.09722 17 2.74653 16.8507 2.44792 16.5521C2.14931 16.2535 2 15.9028 2 15.5V6.5C2 6.09722 2.14931 5.74653 2.44792 5.44792C2.74653 5.14931 3.09722 5 3.5 5H6L7.5 3H12.5L14 5H16.5C16.9125 5 17.2656 5.14931 17.5594 5.44792C17.8531 5.74653 18 6.09722 18 6.5V15.5C18 15.9028 17.8531 16.2535 17.5594 16.5521C17.2656 16.8507 16.9125 17 16.5 17H3.5ZM3.5 15.5H16.5V6.5H13.25L11.7479 4.5H8.25L6.75 6.5H3.5V15.5Z"
                            fill="white"
                          />
                        </svg>
                        <input
                          type="file"
                          ref="fileInput"
                          @change="handleFileChange"
                          class="d-none"
                          accept="image/*"
                        />
                      </span>
                    </span>
                    <span class="d-flex flex-column ga-2">
                      <span class="profile-box-main-text profile-box-name">
                        {{ profile.first_name + " " + profile.last_name }}
                      </span>
                      <span class="profile-box-second-text">
                        {{ profile?.role }}
                      </span>
                      <span
                        class="text-red-accent-4 text-caption small-text mt-2"
                        v-if="errors.image"
                      >
                        {{ errors.image }}
                      </span>
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <BasicInfo
              :profile="profile"
              :errors="errors"
              @change:firstName="handleFirstNameChange"
              @change:lastName="handleLastNameChange"
              @change:dateOfBirth="handleDateOfBirthChange"
            />
            <ContactInfo
              :profile="profile"
              :errors="errors"
              @change:email="handleEmailChange"
              @change:phone="handlePhoneChange"
            />
            <Password
              :profile="profile"
              :errors="errors"
              @change:currentPassword="handleCurrentPasswordChange"
              @change:newPassword="handleNewPasswordChange"
              @change:confirmPassword="handleConfirmPasswordChange"
            />
            <General
              :profile="profile"
              :errors="errors"
              @change:language="handleLanguageChange"
            />
          </div>
          <div class="d-flex justify-end bottom-0 right-0 w-100 pa-5">
            <button class="choose-btn" @click="updateProfile">
              {{ $t("update") }}
            </button>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      location="top"
      close-on-content-click
    >
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import ProfilePicture from "@/components/myAccount/edit/ProfilePicture.vue";
import General from "@/components/myAccount/edit/General.vue";
import Password from "@/components/myAccount/edit/Password.vue";
import BasicInfo from "@/components/myAccount/edit/BasicInfo.vue";
import ContactInfo from "@/components/myAccount/edit/ContactInfo.vue";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";

export default {
  name: "EditMyAccount",

  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    ProfilePicture,
    General,
    Password,
    BasicInfo,
    ContactInfo,
  },

  data() {
    return {
      componentKey: 0,
      showNav: true,
      profilePicture: this.profile?.image,
      loading: true,
      profilePicture: null,
      gen_store: useGeneralStore(),
      linksData: [
        { name: "home", link: "/" },
        { name: "setting", link: "/my-account" },
        { name: "myAccount", link: "" },
      ],
      form: {
        image: null,
        first_name: "",
        last_name: "",
        email: "",
        mobile: "",
        old_password: "",
        password: "",
        password_confirmation: "",
        lang: "",
        date_of_birth: "",
      },
      snackbar: {
        color: "",
        show: false,
        message: "",
        timeout: 3000,
      },
      errors: {},
      profile: [],
      loading: false,
    };
  },

  methods: {
    // Form field handlers
    HideLoading() {
      this.showLoader = false;
    },
    UploadProfilePicture() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.profilePicture = file;
        this.generatePreview(file);
        this.$emit("change", file);
      }
    },
    generatePreview(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.profilePicture = e.target.result;
      };
      reader.readAsDataURL(file);
      this.form.image = file; // Update the form data with the selected file
    },
    handleFirstNameChange(value) {
      this.form.first_name = value;
    },
    handleLastNameChange(value) {
      this.form.last_name = value;
    },
    handleDateOfBirthChange(value) {
      this.form.date_of_birth = value;
    },
    handleEmailChange(value) {
      this.form.email = value;
    },
    handlePhoneChange(value) {
      this.form.mobile = value;
    },
    handleCurrentPasswordChange(value) {
      this.form.old_password = value;
    },
    handleNewPasswordChange(value) {
      this.form.password = value;
    },
    handleConfirmPasswordChange(value) {
      this.form.password_confirmation = value;
    },
    handleLanguageChange(value) {
      this.form.lang = value;
    },

    validateForm() {
      const rules = {
        image: (value) => (value ? true : "Please upload a valid image."),
        first_name: (value) =>
          value?.trim().length > 0 && value.length <= 255
            ? true
            : "First name is required and must be under 255 characters.",
        last_name: (value) =>
          value?.trim().length > 0 && value.length <= 255
            ? true
            : "Last name is required and must be under 255 characters.",
        email: (value) =>
          /^\S+@\S+\.\S+$/.test(value)
            ? true
            : "Please enter a valid email address.",
        mobile: (value) =>
          /^\d{10,15}$/.test(value)
            ? true
            : "Mobile number must be 10-15 digits long.",
        old_password: (value) =>
          value?.length === 0 ? "Old Password is required." : true,
        password: (value) =>
          value?.length > 0 && value.length < 6
            ? "Password must be at least 6 characters."
            : true,
        password_confirmation: (value) =>
          value != this.form.password ? "Passwords do not match." : true,
        lang: (value) =>
          ["en", "ar"].includes(value)
            ? true
            : 'Language must be "en" or "ar".',
        date_of_birth: (value) =>
          !isNaN(Date.parse(value)) || "Please enter a valid date.",
      };

      this.errors = {};
      Object.entries(this.form).forEach(([key, value]) => {
        const rule = rules[key];
        if (rule) {
          const result = rule(value);
          if (result !== true) this.errors[key] = result;
        }
      });

      return Object.keys(this.errors).length === 0;
    },

    showSnackbar(message, color) {
      this.snackbar = { message, color, show: true, timeout: 3000 };
    },
    getProfile() {
      this.loading = true;
      apiClient
        .get("/my-account/get/account")
        .then((response) => {
          this.profile = response.data.data;
          this.profilePicture = this.profile.image;

          const localUser = JSON.parse(localStorage.getItem("user")) || {
            data: {},
          };
          localUser.data.name = `${this.profile.first_name} ${this.profile.last_name}`;
          localUser.data.image = this.profile.image;
          localUser.data.email = this.profile.email;
          localStorage.setItem("user", JSON.stringify(localUser));
        })
        .catch((error) => {
          console.error("Error fetching profile:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newimage() {
      apiClient
        .get("/my-account/get/account")
        .then((response) => {
          this.profile = response.data.data;
          this.profilePicture = this.profile.image;

          const localUser = JSON.parse(localStorage.getItem("user")) || {
            data: {},
          };
          localUser.data.name = `${this.profile.first_name} ${this.profile.last_name}`;
          localUser.data.image = this.profile.image;
          localUser.data.email = this.profile.email;
          localStorage.setItem("user", JSON.stringify(localUser));
        })
        .catch((error) => {
          console.error("Error fetching profile:", error);
        }).finally(() => {
          window.location.reload();
        });
    },
    updateProfile() {
      this.gen_store.ShowLoading();
      if (this.validateForm()) {
        let formData = new FormData();

        // Append all fields to formData
        formData.append("image", this.form.image);
        formData.append("first_name", this.form.first_name);
        formData.append("last_name", this.form.last_name);
        formData.append("email", this.form.email);
        formData.append("mobile", this.form.mobile);
        formData.append("old_password", this.form.old_password);
        formData.append("password", this.form.password);
        formData.append(
          "password_confirmation",
          this.form.password_confirmation
        );
        formData.append("lang", this.form.lang);
        formData.append("date_of_birth", this.form.date_of_birth);
        setTimeout(() => {
          apiClient
            .post("/my-account/update/account", formData, {
              headers: {
                "Content-Type": "multipart/form-data", // Important for file uploads
              },
            })
            .then((response) => {
              console.log(this.form.image, "response data");
              this.showSnackbar("Profile updated successfully!" , "#237276");
              this.newimage();
              this.gen_store.HideLoading();
            })
            .catch((error) => {
              this.showSnackbar(error);
              this.gen_store.HideLoading();
            });
        }, 1000);
      } else {
        this.showSnackbar("Please fix the errors and try again.", "error");
        this.gen_store.HideLoading();
      }
    },
  },
  mounted() {
    this.getProfile();
  },
};
</script>
